import { render, staticRenderFns } from "./AddUserRole.vue?vue&type=template&id=6249be82&scoped=true"
import script from "./AddUserRole.vue?vue&type=script&lang=js"
export * from "./AddUserRole.vue?vue&type=script&lang=js"
import style0 from "./AddUserRole.vue?vue&type=style&index=0&id=6249be82&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249be82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6249be82')) {
      api.createRecord('6249be82', component.options)
    } else {
      api.reload('6249be82', component.options)
    }
    module.hot.accept("./AddUserRole.vue?vue&type=template&id=6249be82&scoped=true", function () {
      api.rerender('6249be82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/AddUserRole.vue"
export default component.exports